import BookingList from './List'
import OrderItemEdit from './Edit'
import OrderItemCreate from './Create'

import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket'

export default {
  list: BookingList,
  edit: OrderItemEdit,
  create: OrderItemCreate,
  icon: ShoppingBasketIcon
}
